"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _InactiveOrdersComponent = _interopRequireDefault(require("./InactiveOrdersComponent"));
var _futuresOrdersSelectors = require("../../../redux/futures/selectors/futuresOrdersSelectors");
var _instrumentPositionSelectors = require("../../../redux/selectors/instrumentPositionSelectors");
var _futuresOrdersActions = require("../../../redux/futures/actions/futuresOrdersActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var selectedInstrument = _ref.selectedInstrument;
  var inactiveOrders = (0, _futuresOrdersSelectors.futuresInactiveOrdersSelector)(state);
  var instruments = (0, _instrumentPositionSelectors.instrumentSelectorInstruments)(state);
  var fetching = (0, _futuresOrdersSelectors.futuresInactiveOrdersFetchingSelector)(state);
  return {
    data: inactiveOrders,
    instruments: instruments,
    fetching: fetching,
    selectedInstrument: selectedInstrument,
    selectedAccountId: (0, _get["default"])(state, 'user.selectedAccountId', 0),
    OMSId: (0, _get["default"])(state, 'user.userInfo.OMSId', 1),
    isFutures: true
  };
};
var mapDispatchToProps = {
  getInactiveOrders: _futuresOrdersActions.getFuturesInactiveOrders,
  resetActivePage: _futuresOrdersActions.resetFuturesActivePage
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InactiveOrdersComponent["default"]);